import { useLoginStore } from "hooks/Login";
import React from "react";
import { useEffect } from "react";
import { UncontrolledAlert } from "reactstrap";

function Alert() {
  const [{ alertList }, {}, { resetAlerts }] = useLoginStore();
    useEffect(() => {
      const timeId = setTimeout(async () => {
        await resetAlerts();
      }, 10000);

      return () => {
        clearTimeout(timeId);
      };
    }, [alertList]);

  const getTheme = (type) => {
    switch (type) {
      case "success":
        return {
          bg: "linear-gradient(135deg, #d3f9d8, #b2f2bb)",
          bar: "linear-gradient(to right, #51cf66, #2f9e44)",
          text: "#1b4332",
          border: "#69db7c",
        };
      case "danger":
        return {
          bg: "linear-gradient(135deg, #ffe3e3, #ffc9c9)",
          bar: "linear-gradient(to right, #ff6b6b, #fa5252)",
          text: "#721c24",
          border: "#ffa8a8",
        };
      default: // warning
        return {
          bg: "linear-gradient(135deg, #fff4e6, #ffe8cc)",
          bar: "linear-gradient(to right, #fab005, #fd7e14)",
          text: "#7f4f24",
          border: "#ffd8a8",
        };
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
      }}
    >
      {alertList.map((v, i) => {
        const theme = getTheme(v.type);
        return (
          <div
            key={i}
            className="fancy-toast"
            style={{
              background: theme.bg,
              border: `1px solid ${theme.border}`,
              color: theme.text,
            }}
          >
            <span>{v.message}</span>
            <span
              className="fancy-toast-close"
              style={{
                fontSize: "1.8rem",
                top: "3px",
              }}
              onClick={() => resetAlerts(i)}
            >
              ×
            </span>
            <div
              className="fancy-toast-bar"
              style={{ background: theme.bar }}
            />
          </div>
        );
      })}
    </div>
  );
}

export default Alert;
